export const availableBlockSelectorActionCodes = [
    "CREATE_NEW_SCRAPE_TASK",
    "CREATE_NEW_LIST_SCRAPE_TASK",
    "CREATE_NEW_SCRAPE_TASK_POST",
    "CREATE_NEW_LIST_SCRAPE_TASK_POST",
    "CREATE_NEW_CALLBACK_SCRAPE_TASK_POST"
];

export const DEFAULT_SELECTOR = {
    name: null,
    type_code: "XPATH",
    action_code: "CREATE_NEW_LIST_SCRAPE_TASK",
    condition_type_code: "ALL",

    is_required: false,
    is_multiple: false,

    selectors: [],
    normalizers: [],
    default_values: []
};
